import { useWorkspace } from '@/context';
import { useSavedActions } from '@/hooks/useSavedActions';
import { SavedActions } from '@/components/Workspace/SavedActions';

function SavedActionsPage() {
  const { effectiveRole, effectiveUser } = useWorkspace();
  const { actions, saveAction, removeAction, togglePin } = useSavedActions(effectiveRole);

  return (
    <div className="workspace">
      <div className="workspace__inner saved-actions-page">
        <header className="saved-actions-page__header">
          <h1 className="greeting__headline">Saved actions</h1>
          <p className="greeting__subtitle">
            Reusable workflow templates for common operations at {effectiveUser.site}. In chat, type{' '}
            <kbd>/</kbd> to pick one quickly.
          </p>
        </header>

        <SavedActions
          actions={actions}
          onSave={saveAction}
          onRemove={removeAction}
          onTogglePin={togglePin}
        />
      </div>
    </div>
  );
}

export default SavedActionsPage;
